import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
export namespace NCmsHtml {
    export interface IComponentData extends NICmsContentComponent.IData {
        text: string;
    }
}
@ICmsComponent<CmsHtmlComponent>({
    id: 'html',
    name: 'Free HTML',
    tags: ['text', 'html'],
    fields: [
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-general',
            title: 'General'
        },
        <NICmsContentField.IField>{
            key: 'text',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Copy with HTML tags allowed',
            default: 'Lorem ipsum dolor',
            required: true
        }
    ]
})
@Component({
    selector: 'cms-html',
    templateUrl: './cms-html.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, ICmsClientModule]
})
export class CmsHtmlComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsHtml.IComponentData;
}
